// extracted by mini-css-extract-plugin
export default {"children":"containerViewBoard_children__3Uzk0"};